import React from 'react';
import styles from '../styles/common.less';

const LEGEND_AFTER_FIX = {
  isp: '星',
  region: '%',
};

const LEGEND_DATA = [
  { rewardPercentage: '五', rewardLevel: 5 },
  { rewardPercentage: '四', rewardLevel: 4 },
  { rewardPercentage: '三', rewardLevel: 3 },
  { rewardPercentage: '二', rewardLevel: 2 },
  { rewardPercentage: '一', rewardLevel: 1 },
];

const ChartLegend = ({ data = LEGEND_DATA, type = 'isp' }) => {
  return (
    <ul className={styles.chartLevels}>
      {data?.map((item,index) => {
        const { rewardPercentage, rewardLevel } = item;
        return (
          <li key={index} className={`${styles.levelItem} ${styles[`level-${rewardLevel}`]}`}>
            {rewardPercentage}
            {LEGEND_AFTER_FIX[type]}
          </li>
        );
      })}
    </ul>
  );
};

export default ChartLegend;
